import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Link } from "react-router-dom";
import clientResultsData from "../data/clientResults";
import FaqsData from "../data/faqs";

const FAQs = ({ heading }) => {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <div>
      <div className="max-w-[1320px] mx-auto py-12  border-8 border-red-600">
        <h1
          className={`md:text-[43px] text-[30px] text-center ${
            heading === "FAQs" ? "lg:text-center " : "lg:text-left"
          }
          font-bold  mb-20  text-[#1b0c3e] mt-12`}
        >
          {heading}
        </h1>
        {FaqsData.map((item, index) => (
          <Accordion
            key={item.id}
            expanded={expanded === item.id}
            onChange={handleChange(item.id)}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
            >
              <Typography>
                <div className="flex items-center md:p-2">
                  <p className="text-2xl text-[#1b0c3e] p-2">{item.question}</p>
                </div>
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                <div className="max-w-[1320px] md:mx-auto mx-4  md:p-2">
                  <p className="p-2 text-[18px] -mt-4 text-[#4f4f4f]">
                    {item.answer1}
                  </p>
                  {item.answer2 && (
                    <p className="p-2 text-[18px] mt-1 text-[#4f4f4f]">
                      {item.answer2}
                    </p>
                  )}
                  {item.answer3 && (
                    <p className="p-2 text-[18px] mt-1 text-[#4f4f4f]">
                      {item.answer3}
                    </p>
                  )}
                  {item.answer4 && (
                    <p className="p-2 text-[18px] mt-1 text-[#4f4f4f]">
                      {item.answer4}
                    </p>
                  )}
                </div>
              </Typography>
            </AccordionDetails>
          </Accordion>
        ))}
        {heading !== "FAQs" && (
          <div className="py-10 my-8 text-center md:py-16">
            <Link to="/category/case-studies">
              <button className="md:py-4 md:px-6 p-3 m-1  md:text-2xl text-xl font-semibold bg-[#f8cc84] hover:bg-[#e8c181] transition duration-200 ease-out text-[#1b0c3e] text-center mx-auto">
                Book a free consultation!
              </button>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default FAQs;
